// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724663203585/c2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724663295237/d2.jpg',
    },
    NA: {
        pc: '',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725155340845/euPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725155340312/euH2.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725162852655/ukPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725162852099/ukH2.jpg',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736750480093/waterproof.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736905844155/%E9%98%B2%E6%B0%B4.jpg',
    },
};
const imgLocale: any = {
    jp: imgAllA.JP,
    us: imgAllA.JP,
    ca: imgAllA.JP,
    br: imgAllA.JP,
    mx: imgAllA.JP,
    au: imgAllA.AU,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    nl: imgAllA.EU,
};
export default imgLocale;
